module.exports = __webpack_public_path__ + "static/media/t_big_03.db77d8b4.png";